<div class="d-flex ion-justify-content-end w-100">
  <ion-button class="clear-btn modal-close-btn padt10" (click)="closeModal()">
    <ion-icon
      class="primary-icon-color"
      slot="icon-only"
      name="close-outline"
    ></ion-icon>
  </ion-button>
</div>
<div class="d-flex ion-justify-content-center w-100">
  <ion-img src="/assets/svg/hotelDealsReqAlert.svg" class="alertIcon"></ion-img>
</div>
<p [innerHtml]="descriptionText | safeHtml"></p>
<div class="d-flex ion-justify-content-center w-100 marb10 ion-no-padding">
  <ion-button class="primary-btn confirm-btn" (click)="closeModal()"
    >Confirm</ion-button
  >
</div>
